import { render, staticRenderFns } from "./FcontinueCreate.vue?vue&type=template&id=22cda7db&"
import script from "./FcontinueCreate.vue?vue&type=script&lang=js&"
export * from "./FcontinueCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports